import React from "react";
import configLogo1 from "../logos/configTypeIcons/1-config-type.png";
import configLogo2 from "../logos/configTypeIcons/2-config-type.png";
import configLogo3 from "../logos/configTypeIcons/3-config-type.png";
import configLogo4 from "../logos/configTypeIcons/4-config-type.png";
import configLogo5 from "../logos/configTypeIcons/5-config-type.png";
import configLogo6 from "../logos/configTypeIcons/6-config-type.png";
import configLogo7 from "../logos/configTypeIcons/7-config-type.png";
import underwriter from "../logos/configTypeIcons/underwriter.webp";

export const ConfigIcon = ({ configType, style }) => {
  let [configLogo, setconfigLogo] = React.useState(configLogo1);
  const size = "1.7vw";
  React.useEffect(() => {
    switch (configType) {
    case 1:
      setconfigLogo(configLogo1)
      break;
      case 2:
      setconfigLogo(configLogo2)
      break;
    case 3:
      setconfigLogo(configLogo3)
      break;
    case 4:
      setconfigLogo(configLogo4)
      break;
    case 5:
      setconfigLogo(configLogo5)
      break;
    case 6:
      setconfigLogo(configLogo6)
      break;
    case 9:
      setconfigLogo(underwriter)
      break;
    case 7:
      setconfigLogo(configLogo7)
      break;
    case 10:
      setconfigLogo("");
      break;
      default:
        setconfigLogo(configLogo1)
      }
    }, [configType]);
  return (
    <>
      <img
        src={configLogo}
        alt={`config-type-icon${configType}`}
        style={{
          ...style,
          borderRadius: "50%",
          width: size,
          height: size,
          cursor: "pointer",
          display: configType == 10 ? "none" : null
        }}
      />
    </>
  );
};
